import React__default, { useRef, useCallback, useEffect } from 'react';

var OVERLAY_CLOSE_ICON_MAP = {
    left: 'icon-double-arrow-left',
    right: 'icon-double-arrow-right',
};
var OverlayItemContent = function (_a) {
    var isOpen = _a.isOpen, position = _a.position, children = _a.children, hasScrollToBottom = _a.hasScrollToBottom, onClose = _a.onClose;
    var closeIcon = OVERLAY_CLOSE_ICON_MAP[position];
    var chatContainer = useRef(null);
    var scrollToMyRef = useCallback(function () {
        if (!chatContainer.current)
            return;
        var scroll = chatContainer.current.scrollHeight - chatContainer.current.clientHeight;
        chatContainer.current.scrollTo(0, scroll);
    }, [chatContainer]);
    useEffect(function () {
        if (hasScrollToBottom && isOpen) {
            scrollToMyRef();
        }
    }, [isOpen]);
    return (React__default.createElement("div", { className: "pgc-overlay-content" },
        React__default.createElement("button", { className: "pgc-overlay-close", onClick: onClose },
            React__default.createElement("i", { className: closeIcon })),
        React__default.createElement("div", { className: "scroll-holder" },
            React__default.createElement("div", { className: "scrollable-container", ref: chatContainer }, children))));
};

export { OverlayItemContent };
